require("./js/app");
require("./_sass/style.scss");


// WEBPACK FOOTER //
// ./webpack.js